var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4042 7.01519C17.4085 7 18.4071 7.009 19.4044 7C19.4649 8.14812 19.8873 9.31762 20.7471 10.1294C21.6052 10.9613 22.819 11.3422 24 11.471V14.4912C22.8933 14.4558 21.7814 14.2308 20.7771 13.765C20.3397 13.5715 19.9322 13.3223 19.5334 13.0674C19.5282 15.2591 19.5426 17.4479 19.519 19.6305C19.4591 20.679 19.1052 21.7225 18.4813 22.5866C17.4776 24.025 15.7355 24.9627 13.9462 24.992C12.8487 25.0533 11.7523 24.7608 10.8171 24.2219C9.26719 23.3286 8.17657 21.6933 8.01773 19.9382C7.99772 19.5665 7.99465 19.1941 8.00852 18.8221C8.14664 17.395 8.86893 16.0297 9.99004 15.101C11.2608 14.0192 13.0409 13.504 14.7076 13.8089C14.7231 14.9199 14.6777 16.0297 14.6777 17.1407C13.9163 16.9 13.0265 16.9675 12.3612 17.4192C11.8744 17.7326 11.5066 18.1937 11.3143 18.7316C11.1555 19.1118 11.2009 19.5343 11.2102 19.9382C11.3926 21.169 12.6035 22.2035 13.8961 22.0916C14.7531 22.0826 15.5743 21.5965 16.0209 20.8849C16.1654 20.6357 16.3271 20.3809 16.3358 20.0878C16.4112 18.7462 16.3812 17.4102 16.3904 16.0685C16.3968 13.0449 16.3812 10.0298 16.4048 7.01575L16.4042 7.01519Z",
    fill: "#223A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.75c99037d364b2e15cc40e7b3c9531c4.svg";
export { ForwardRef as ReactComponent };